import { HIDDEN, VISIBLE } from '../common/actions';
import { LOADER_SPINNER } from './actions';

const initialState = {
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADER_SPINNER[VISIBLE]:
      return { ...state, isLoading: true };
    case LOADER_SPINNER[HIDDEN]:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};

export const getLoaderState = (state) => state.loader.isLoading;
